/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { useState, useCallback, useEffect, useLayoutEffect } from 'react'

const useHideableNavBar = (navBarRef: any, hideOnScroll: boolean) => {
	const [isNavbarVisible, setIsNavbarVisible] = useState(true)
	const [isFocusedAnchor, setIsFocusedAnchor] = useState(false)
	const [lastScrollTop, setLastScrollTop] = useState(0)
	const [navbarHeight, setNavbarHeight] = useState(0)
	// const navbarRef = useCallback((node) => {
	// 	if (node !== null) {
	// 		setNavbarHeight(node.getBoundingClientRect().height)
	// 	}
	// }, [])
	useLayoutEffect(() => {
		if (!navBarRef?.current) return

		const height = navBarRef.current.getBoundingClientRect().height
		if (height !== navbarHeight) setNavbarHeight(height)
	}, [navBarRef, navbarHeight])

	useEffect(() => {
		if (!hideOnScroll) {
			return undefined
		}
		console.log('useEffect')
		console.log(navbarHeight)

		const handleScroll = () => {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop
			console.log(scrollTop)

			if (scrollTop === 0) {
				setIsNavbarVisible(true)
			}

			if (scrollTop < navbarHeight) {
				return
			}

			if (isFocusedAnchor) {
				setIsFocusedAnchor(false)
				setIsNavbarVisible(false)
				setLastScrollTop(scrollTop)
				return
			}

			const documentHeight = document.documentElement.scrollHeight - navbarHeight
			const windowHeight = window.innerHeight

			if (lastScrollTop && scrollTop >= lastScrollTop) {
				setIsNavbarVisible(false)
			} else if (scrollTop + windowHeight < documentHeight) {
				setIsNavbarVisible(true)
			}

			setLastScrollTop(scrollTop)
		}
		window.addEventListener('scroll', handleScroll)

		return () => {
			window.removeEventListener('scroll', handleScroll)
		}
	}, [hideOnScroll, isFocusedAnchor, lastScrollTop, navbarHeight])

	useEffect(() => {
		if (!hideOnScroll) {
			return
		}

		setIsNavbarVisible(true)
	}, [hideOnScroll])

	useEffect(() => {
		if (!hideOnScroll) {
			return
		}

		setIsFocusedAnchor(true)
	}, [hideOnScroll])

	return {
		isNavbarVisible,
	}
}

export default useHideableNavBar
